import HeroSection from "./HeroSection/HeroSection";
import ProcessSection from "./ProcessSection/ProcessSection";
import FeaturesSection from "./FeaturesSection/FeaturesSection";
import ReviewSection from "./ReviewSection/ReviewSection";
import FAQSection from "./FAQSection/FAQSection";

import ProductPagesHOC from "./ProductPagesHOC";
import ProductPageLayout from "./ProductPageLayout";

export { HeroSection, ProcessSection, FeaturesSection, ReviewSection, FAQSection, ProductPagesHOC, ProductPageLayout }